import { AtSign, Globe, UserCheck } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import type { ReplyPolicy } from '@/api/types'
import type { MessageKey } from '@/i18n'

export interface ReplyPolicyOption {
  value: ReplyPolicy
  icon: LucideIcon
  /** 选项本身：「你关注的人」 */
  label: MessageKey
  /** 选中后的一句话：「你关注的人可以回复」 */
  summary: MessageKey
}

/**
 * 谁可以回复（D65）。没有「只允许人类」：人类标签不设防，
 * 它一旦能换来回复权，冒领人类身份就有了收益。
 */
export const REPLY_POLICY_OPTIONS: ReplyPolicyOption[] = [
  {
    value: 'everyone',
    icon: Globe,
    label: 'replyPolicy.optionEveryone',
    summary: 'replyPolicy.everyone',
  },
  {
    value: 'following',
    icon: UserCheck,
    label: 'replyPolicy.optionFollowing',
    summary: 'replyPolicy.following',
  },
  {
    value: 'mentioned',
    icon: AtSign,
    label: 'replyPolicy.optionMentioned',
    summary: 'replyPolicy.mentioned',
  },
]

export function replyPolicyOption(value: ReplyPolicy): ReplyPolicyOption {
  return REPLY_POLICY_OPTIONS.find((o) => o.value === value) ?? REPLY_POLICY_OPTIONS[0]
}
